import React from "react";
import { useNavigate } from "react-router-dom";
import LocalMoviesIcon from "@mui/icons-material/LocalMovies";
import { Movie } from "../../../../utils/types";
import "./index.css";

interface MovieRecommendationsProps {
  recommendedMovies: Movie[];
}

export default function MovieRecommendations({
  recommendedMovies,
}: MovieRecommendationsProps) {
  const navigate = useNavigate();

  return (
    <div className="recommendations-container">
      <h3 className="section-title">Recommended Movies</h3>
      <div className="recommendations-scroll-container">
        {recommendedMovies && recommendedMovies.length > 0 ? (
          recommendedMovies.slice(0, 15).map((recMovie) => {
            const recImgPath =
              recMovie.poster_path ?? recMovie.backdrop_path;
            const recYear = recMovie.release_date
              ? new Date(recMovie.release_date).getFullYear()
              : null;
            return (
              <div
                key={recMovie.id}
                className="rec-movie-card"
                onClick={() => navigate("/detail/" + recMovie.id)}
              >
                {recImgPath ? (
                  <img
                    src={`${process.env.REACT_APP_RAPID_IMAGE_BASE_URL}/w185/${recImgPath}`}
                    alt={recMovie.title}
                    className="rec-movie-poster-new"
                    loading="lazy"
                  />
                ) : (
                  <div className="rec-movie-placeholder-new">
                    <LocalMoviesIcon sx={{ fontSize: 40 }} />
                  </div>
                )}
                <div className="rec-movie-info-new">
                  <h4 className="rec-movie-title-new" title={recMovie.title}>
                    {recMovie.title}
                  </h4>
                  <div className="rec-movie-meta-new">
                    {recMovie.vote_average > 0 && (
                      <div className="rec-rating-pill-new">
                        <img
                          className="rec-imdb-logo-new"
                          alt="IMDB logo"
                          src={require("../../../../assets/ic_imdb.png")}
                        />
                        <span className="rec-rating-value-new">
                          {recMovie.vote_average.toFixed(1)}
                        </span>
                      </div>
                    )}
                    {recYear && (
                      <span className="rec-movie-info-year-new">{recYear}</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="rec-no-data-new">No recommendations found</div>
        )}
      </div>
    </div>
  );
}
